import React from 'react';
import './MemberServiceAccount.scss';
import Checkmark from '../../img/Checkmark.svg';
import LockReset from '../../img/LockReset.svg';
import useAccountUnlockSuccess from './hooks/useAccountUnlockSuccess';
import GenericSkeleton from '../coverage/coverage-details/skeleton/GenericSkeleton';
import { useNavigate } from 'react-router-dom';

const AccountUnlockSuccessPage = () => {
  const navigate = useNavigate();
  const { isLoading, serverError, headingRef } = useAccountUnlockSuccess();
  return isLoading ? (
    <GenericSkeleton />
  ) : (
    <div className="account-success-page-final">
      <div className="account-locked-content unlock-success-content">
        <div className="unlock-success-icon">
          <img
            className="help-card-logo"
            src={!serverError ? Checkmark : LockReset}
            alt={!serverError ? 'success icon' : 'fail icon'}
          />
        </div>

        <div
          role="heading"
          aria-level={1}
          className="sr-only"
          tabIndex={-1}
          ref={headingRef}
        >
          {!serverError
            ? 'Your account has been successfully unlocked'
            : 'Your account cannot be unlocked at the moment.'}
        </div>
        {!serverError ? (
          <h1 aria-hidden={true} className="account-locked-title">
            Your account has been <br /> successfully unlocked
          </h1>
        ) : (
          <h1 aria-hidden={true} className="account-locked-title">
            Your account cannot be unlocked at the moment.
          </h1>
        )}

        <div className="success-page-footer">
          <span>
            {!serverError
              ? 'Login using the new password'
              : 'Try again after some time.'}
          </span>
          <button
            type="button"
            className="unlock-account-btn"
            onClick={() => navigate('/member')}
          >
            {!serverError ? 'LOGIN' : 'LOGIN'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AccountUnlockSuccessPage;
